/**
 * Custom hook for managing user permissions
 * All users are super_admin, so all permissions are granted
 */
export const useUserPermissions = (page = 'users') => {
  // All users are super_admin, return all permissions as true
  return {
    read: true,
    update: true,
    delete: true,
    create: true
  };
};

